import { render, staticRenderFns } from "./AffiliatesNew.vue?vue&type=template&id=891e22aa&scoped=true"
import script from "./AffiliatesNew.vue?vue&type=script&lang=js"
export * from "./AffiliatesNew.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesNew.vue?vue&type=style&index=0&id=891e22aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891e22aa",
  null
  
)

export default component.exports